// Below this many users on either side a gap between the paywalls says nothing
export const MIN_VIEWERS = 100;
const Z_95 = 1.96;

export const rate = (hits, total) => (total > 0 ? hits / total : null);
export const pct1 = (v) => (v == null ? '–' : `${(v * 100).toLocaleString('en-GB', { minimumFractionDigits: 1, maximumFractionDigits: 1 })}%`);
export const points = (v) => `${(Math.abs(v) * 100).toLocaleString('en-GB', { minimumFractionDigits: 1, maximumFractionDigits: 1 })} points`;

// Multi-step minus single-screen, with a 95% range on the gap
export function compareRates(a, b) {
  const pa = rate(a.hits, a.total);
  const pb = rate(b.hits, b.total);
  if (pa == null || pb == null) return null;
  const gap = pa - pb;
  const se = Math.sqrt((pa * (1 - pa)) / a.total + (pb * (1 - pb)) / b.total);
  return { gap, low: gap - Z_95 * se, high: gap + Z_95 * se, clear: gap - Z_95 * se > 0 || gap + Z_95 * se < 0 };
}

const NOT_RANDOM = 'The app takes turns rather than picking at random, and the single-screen paywall always gets the earlier turn, so treat this as a strong hint and not as proof.';

export function buildVerdict(conversion) {
  const { flow, paywall } = conversion.later;
  const flowRate = rate(flow.buyers, flow.viewers);
  const paywallRate = rate(paywall.buyers, paywall.viewers);
  const figures = [
    { label: 'Multi-step', value: pct1(flowRate), note: `${flow.buyers} of ${flow.viewers} users started a subscription` },
    { label: 'Single screen', value: pct1(paywallRate), note: `${paywall.buyers} of ${paywall.viewers} users started a subscription` },
  ];
  if (Math.min(flow.viewers, paywall.viewers) < MIN_VIEWERS) {
    return { status: 'info', title: 'Too early to tell', text: `Each paywall needs at least ${MIN_VIEWERS} users. ${NOT_RANDOM}`, figures };
  }
  const result = compareRates({ hits: flow.buyers, total: flow.viewers }, { hits: paywall.buyers, total: paywall.viewers });
  figures.push({ label: 'Likely gap', value: points(result.gap), note: `Multi-step minus single screen: ${signedPoints(result.low)} to ${signedPoints(result.high)}` });
  if (!result.clear) {
    return { status: 'info', title: 'No clear winner yet', text: `The gap is small enough to be chance. ${NOT_RANDOM}`, figures };
  }
  const winner = result.gap > 0 ? 'Multi-step' : 'Single screen';
  return { status: 'warn', title: `${winner} converts more`, text: `The gap is bigger than chance would explain. ${NOT_RANDOM}`, figures };
}

const signedPoints = (v) => `${v < 0 ? '−' : '+'}${(Math.abs(v) * 100).toLocaleString('en-GB', { maximumFractionDigits: 1 })}`;
